import { __awaiter, __generator } from "tslib";
import { PublicClientApplication } from '@azure/msal-browser-1p';
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchFeatureSettings, getFeatureSettings, } from '@office-start/feature-settings-service';
import { fetchIdentity } from '@office-start/identity-service';
import { now } from '@office-start/performance-utility';
import { logError, logRequest } from '@office-start/telemetry-service';
import { getErrorString } from './getErrorString';
import { redirectToLogin } from './redirectToLogin';
import { setupOfficeHomeTokenRefresh } from './setupOfficeHomeTokenRefresh';
import { setupSpaTokenRefresh } from './setupSpaTokenRefresh';
var initializePromise;
var msalClient;
export var tokenResourceIdMap = new Map();
export function getMsalClient() {
    return __awaiter(this, void 0, void 0, function () {
        var featureSettingsResult, settings, _a;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (initializePromise) {
                        return [2 /*return*/, initializePromise];
                    }
                    featureSettingsResult = getFeatureSettings();
                    if (!(featureSettingsResult === null || featureSettingsResult === void 0 ? void 0 : featureSettingsResult.result)) return [3 /*break*/, 1];
                    _a = featureSettingsResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchFeatureSettings()];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3:
                    settings = _a;
                    initializePromise = fetchIdentity().then(function (identity) {
                        return fetchOfficeComponentContext().then(function (context) { return __awaiter(_this, void 0, void 0, function () {
                            var authOptions, config, perfTelemetryReporterConfig, appConfig, spaAuthCodeElement, account;
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        initializeTokenResourceMap(settings.result || {}, identity);
                                        authOptions = (_a = settings.result) === null || _a === void 0 ? void 0 : _a.authOptions;
                                        config = {
                                            auth: {
                                                clientId: (_b = authOptions === null || authOptions === void 0 ? void 0 : authOptions.aadAppId) !== null && _b !== void 0 ? _b : '',
                                                redirectUri: "https://".concat(window.location.host).concat(authOptions === null || authOptions === void 0 ? void 0 : authOptions.spaRedirectUrlPath),
                                                authority: (authOptions === null || authOptions === void 0 ? void 0 : authOptions.aadAuthorityUrlRoot) +
                                                    "/".concat(identity.tenantId),
                                            },
                                            cache: {
                                                cacheLocation: 'localStorage',
                                                claimsBasedCachingEnabled: true,
                                            },
                                        };
                                        perfTelemetryReporterConfig = undefined;
                                        appConfig = {
                                            appName: 'M365Web',
                                            appVersion: '1.0.0',
                                        };
                                        perfTelemetryReporterConfig = {
                                            disabled: false,
                                            enableMATS: true,
                                            appName: appConfig.appName,
                                            appVersion: appConfig.appVersion,
                                        };
                                        msalClient = new PublicClientApplication(config, perfTelemetryReporterConfig);
                                        return [4 /*yield*/, msalClient.initialize()];
                                    case 1:
                                        _d.sent();
                                        if (context.inMockMode) {
                                            return [2 /*return*/, msalClient];
                                        }
                                        spaAuthCodeElement = document.getElementById('spa-auth-code');
                                        if (spaAuthCodeElement && spaAuthCodeElement.textContent) {
                                            return [2 /*return*/, initializeWithSpaAuthCode(spaAuthCodeElement.textContent, (_c = authOptions === null || authOptions === void 0 ? void 0 : authOptions.officeHomeTokenScope) !== null && _c !== void 0 ? _c : '', identity)];
                                        }
                                        account = msalClient
                                            .getAllAccounts()
                                            .find(function (a) {
                                            var _a;
                                            return ((_a = a.idTokenClaims) === null || _a === void 0 ? void 0 : _a.oid) === identity.objectId &&
                                                a.tenantId == identity.tenantId;
                                        });
                                        // If we can't find the account, relogin the user.
                                        if (!account) {
                                            logError({
                                                eventName: 'Msal_AccountNotFound',
                                                errorType: 'Authentication_Failed',
                                                debugInfo: "spauthcode present: ".concat(!!spaAuthCodeElement),
                                            });
                                            redirectToLogin(identity, 'NoAccountOnStart');
                                            return [2 /*return*/, msalClient];
                                        }
                                        msalClient.setActiveAccount(account);
                                        initializeAuthStateHandlers(identity);
                                        return [2 /*return*/, msalClient];
                                }
                            });
                        }); });
                    });
                    return [2 /*return*/, initializePromise];
            }
        });
    });
}
function initializeWithSpaAuthCode(spaAuthCode, scope, identity) {
    return __awaiter(this, void 0, void 0, function () {
        var eventName, startTime, tokenResult, endTime, ex_1, msalError, endTime;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    eventName = 'Msal_AuthCodeExchange';
                    startTime = now();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, msalClient.acquireTokenByCode({
                            code: spaAuthCode,
                            scopes: [scope],
                        })];
                case 2:
                    tokenResult = _a.sent();
                    endTime = now();
                    logRequest({
                        eventName: eventName,
                        httpCode: 200,
                        latency: endTime - startTime,
                    });
                    msalClient.setActiveAccount(tokenResult.account);
                    initializeAuthStateHandlers(identity);
                    return [3 /*break*/, 4];
                case 3:
                    ex_1 = _a.sent();
                    msalError = ex_1;
                    endTime = now();
                    logRequest({
                        eventName: eventName,
                        httpCode: 500,
                        latency: endTime - startTime,
                        error: getErrorString(msalError),
                    });
                    // To maintain parity with non-hybrid auth, we relogin the user after 1 minute if we fail to exchange the auth code.
                    window.setTimeout(function () {
                        redirectToLogin(identity, 'AuthCodeExchangeFailed');
                    }, 60 * 1000 /* 1 minute */); // TODO: get this timeout value from config.
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, msalClient];
            }
        });
    });
}
function initializeAuthStateHandlers(identity) {
    setupOfficeHomeTokenRefresh();
    setupSpaTokenRefresh(identity);
}
function initializeTokenResourceMap(featureSettings, identity) {
    var authConfig = featureSettings.authOptions || {};
    var resourceSettings = featureSettings.resources || {};
    tokenResourceIdMap.set('OfficeHome', {
        id: authConfig.officeHomeTokenScope,
        includesScope: true,
    });
    tokenResourceIdMap.set('Portal', { id: resourceSettings.adminPortal });
    tokenResourceIdMap.set('BingAnswers', { id: resourceSettings.bingAnswers });
    tokenResourceIdMap.set('SharedServices', {
        id: resourceSettings.sharedServices,
    });
    tokenResourceIdMap.set('ConsumerShellService', {
        id: resourceSettings.consumerShellServiceV2,
    });
    tokenResourceIdMap.set('FluidPushChannel', {
        id: resourceSettings.pushChannel,
    });
    tokenResourceIdMap.set('Forms', { id: resourceSettings.forms });
    tokenResourceIdMap.set('Graph', { id: resourceSettings.graph });
    tokenResourceIdMap.set('Loki', { id: resourceSettings.loki });
    tokenResourceIdMap.set('MfsService', { id: resourceSettings.mfs });
    tokenResourceIdMap.set('MruPlusPlus', identity.isMsa
        ? { id: resourceSettings.mruMsaV2, includesScope: true }
        : { id: resourceSettings.mru });
    tokenResourceIdMap.set('MyApps', { id: resourceSettings.myApps });
    tokenResourceIdMap.set('Notify', { id: resourceSettings.notify });
    tokenResourceIdMap.set('Ods', { id: resourceSettings.ods });
    tokenResourceIdMap.set('OneNote', { id: resourceSettings.oneNote });
    tokenResourceIdMap.set('Portal', { id: resourceSettings.adminPortal });
    tokenResourceIdMap.set('QueryFormulation', {
        id: resourceSettings.autosuggest,
    });
    tokenResourceIdMap.set('Substrate', { id: resourceSettings.substrate });
    tokenResourceIdMap.set('Sway', { id: resourceSettings.sway });
    tokenResourceIdMap.set('TenantFeedback', {
        id: resourceSettings.tenantFeedback,
    });
    tokenResourceIdMap.set('Thor', { id: resourceSettings.thor });
    tokenResourceIdMap.set('Yammer', { id: resourceSettings.yammer });
    tokenResourceIdMap.set('AugLoop', { id: resourceSettings.augLoop });
    tokenResourceIdMap.set('VisioService', { id: resourceSettings.visio });
    tokenResourceIdMap.set('CaptureService', { id: resourceSettings.capture });
    tokenResourceIdMap.set('WCSS', { id: resourceSettings.shellWeb });
}
//# sourceMappingURL=getMsalClient.js.map